// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import styled from 'styled-components';

const S = {
  LeftPath: styled.path`
    animation: moveLeft infinite;
    animation-delay: 300ms;
    animation-timing-function: cubic-bezier(Ease Out);
    animation-duration: 1000ms;

    @keyframes moveLeft {
      0% { transform: rotate(0deg); }
      50% { transform: rotate(-5deg); }
      100% { transform: rotate(0deg); }
    }
  `,
  RightPath: styled.path`
    animation: moveRight infinite;
    animation-delay: 300ms;
    animation-timing-function: cubic-bezier(Ease Out);
    animation-duration: 1000ms;
    @keyframes moveRight {
      0% { transform: rotate(0deg); }
      50% { transform: rotate(5deg); transform-origin: top right; }
      100% { transform: rotate(0deg); }
    }
  `
};

export default function LinerLoading():JSX.Element {
  return (
    <svg height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <S.LeftPath d="M0 0V13.4685C0.000264116 15.2547 0.715376 16.9675 1.98804 18.2304C3.26071 19.4933 4.9867 20.2028 6.78638 20.2028V6.73428C6.78612 4.94815 6.07101 3.23525 4.79834 1.97236C3.52568 0.70947 1.79969 -1.92344e-08 0 0Z" fill="#FFD163"/>
      <S.RightPath d="M10.6406 6.73428V20.2028C11.5318 20.2029 12.4143 20.0288 13.2377 19.6903C14.061 19.3519 14.8091 18.8558 15.4393 18.2303C16.0694 17.6048 16.5692 16.8623 16.9101 16.0451C17.251 15.2279 17.4263 14.352 17.426 13.4675V0C16.5349 0 15.6526 0.174194 14.8294 0.512622C14.0061 0.85105 13.2581 1.34709 12.628 1.97242C11.9979 2.59776 11.4981 3.34013 11.1571 4.15717C10.8161 4.97421 10.6406 5.84992 10.6406 6.73428Z" fill="#FFD163"/>
    </svg>
  )
}
